// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__37SMn","gfeWrapper":"CalendarEvent_gfeWrapper__1DmQ2"};